import React from "react";
import Typography from "@mui/material/Typography";
import { UserName } from "../users/UserName";

/**
 * @param {import("react").ReactNode[]} nodes
 */
export const formatDesigners = (nodes) => {
  if (nodes.length === 0) {
    return "unknown";
  }
  if (nodes.length === 1) {
    return nodes;
  }

  const allButLast = nodes.slice(0, -1);
  const last = nodes.slice(-1);

  return `${allButLast.join(", ")} & ${last.join("")}`;
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").GameDesigners[]} props.designers
 */
export const Automatic = ({ designers }) => {
  if (designers.length === 1) {
    return (
      <Typography variant="inherit">
        <UserName userId={designers[0].designerId} />
      </Typography>
    );
  }

  const children = designers.map((designer, index) => {
    const hasPrefix = index === designers.length - 1;
    const hasSuffix = index < designers.length - 2;

    return (
      <Typography key={designer.designerId} variant="inherit" display="inline">
        {hasPrefix ? " & " : ""}
        <UserName userId={designer.designerId} />
        {hasSuffix ? ", " : ""}
      </Typography>
    );
  });

  return <Typography variant="inherit">{children}</Typography>;
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Game} props.game
 */
export const Designers = ({ game }) => {
  if (game.customAuthors) {
    return <Typography variant="inherit">{game.customAuthors}</Typography>;
  }

  return <Automatic designers={game.designers} />;
};
